import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../service/dashboard/dashboard.service';
import * as moment from 'moment';
import { NzMessageService } from 'ng-zorro-antd/message';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {
  dateFormat = 'yyyy/MM/dd';
  size = 'large';
  showTableData = [];
  questionnaireTable_info = [];
  searchLoading = false;
  downloadLoading = false;
  selectedDate = [];
  selectConfig = {
    insertDate: [],
    isHidden: 'Y'
  }
  constructor(
    private dashboardService: DashboardService,
    private message: NzMessageService,
    private http: HttpClient
  ) { }

  async ngOnInit() {
    const configList = await this.http.get('./assets/config/excel.json').toPromise();
    this.questionnaireTable_info = configList['questionnaireTable_info'];
    this.getDownloadData();
  }
  async getDownloadData() {
    try {
      this.searchLoading = true;
      for (const key in this.selectConfig) {
        if (Object.prototype.hasOwnProperty.call(this.selectConfig, key)) {
          if (this.selectConfig[key]) {
            if (key == 'insertDate') {
              if (!this.selectConfig[key][0] && !this.selectConfig[key][1]) {
                this.selectConfig['insertDate'] = [];
              } else {
                const startDate = moment(this.selectConfig[key][0]).format('YYYY-MM-DD');
                const endDate = moment(this.selectConfig[key][1]).format('YYYY-MM-DD');
                this.selectConfig['insertDate'] = [startDate, endDate];
              }
            }
          }
        }
      }
      setTimeout(() => {
        this.getDefaultData();
      }, 1000);
    } catch (error) {
      if (JSON.stringify(error)) {
        error = error ;
      } else {
        error = JSON.stringify(error) ;
      }
      this.message.create('error', error);
      this.searchLoading = false;
    }
  }
  async getDefaultData() {
    try {
      this.searchLoading = true;
      this.showTableData = [];
      if (this.selectConfig.isHidden) {
        const dataList = await this.dashboardService.getRecordList(this.selectConfig).toPromise();
        if (dataList.code === 200) {
          if (dataList.data.length) {
            this.showTableData = dataList.data;
            for (const data of this.showTableData) {
              data.insertDate=((data.insertDate).split(".")[0]).replace(/T/,' ')
              if (data.uploadTime) {
                data.uploadTime = moment(data.uploadTime).format("YYYY-MM-DD HH:mm:ss");
               }
            }
          } else {
            this.searchLoading = false;
            this.message.create('warning','暂无数据');
          }
        } else {
          this.message.create('error', `查询失败:${dataList.msg}`);
        }
        this.searchLoading = false;
      }
    } catch (error) {
      this.searchLoading = false;
      this.message.create('error', JSON.stringify(error));
    }
  }
  clearQuery() {
    this.selectConfig = {
      insertDate: [],
      isHidden: 'Y'
    }
    this.getDownloadData();
  }
  //下载报表
  downData(){
    try{
      this.downloadLoading = true;
      const downloadData = [];
      for (const item of this.showTableData) {
        const saveData = {};
        if (item['insertDate']) {
          item['insertDate'] = moment(item['insertDate']).format('YYYY-MM-DD HH:mm:ss');
        }
        delete item.id;
        // 將下載下來的表頭處理成頁面表格顯示的名稱
        for (const key in this.questionnaireTable_info) {
          if (Object.prototype.hasOwnProperty.call(this.questionnaireTable_info, key)) {
            const list = this.questionnaireTable_info[key];
            if (list) {
              saveData[list.label] = item[list.prop];
            }
          }
        }
        downloadData.push(saveData);
      }
      const excelName = '离职问卷报表';
      this.dashboardService.exportArryAsExcelFile(downloadData, excelName);
      setTimeout(() => {
        this.downloadLoading = false;
      }, 1000);

    }catch(error){
      if (JSON.stringify(error)) {
        error = error ;
      } else {
        error = JSON.stringify(error) ;
      }
      this.message.create('error', error);
      this.downloadLoading = false;
    }
  }
}
